import { SolicitudStepper } from "@/components/ui/solicitud-stepper";
import type { SolicitudDetalle } from "@/lib/types";
import { estaEnEsperaDeAutorizacion } from "@/features/solicitud-detalle/utils/estado-flags";
import { EsperaDeAutorizacionView } from "./EsperaDeAutorizacionView";
import { DetalleTabs } from "./DetalleTabs";
import { DetalleSidebar } from "./DetalleSidebar";

export function DetalleLayout({ sol }: { sol: SolicitudDetalle }) {
  const enEspera = estaEnEsperaDeAutorizacion(sol.estado);
  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="order-2 col-span-12 md:col-span-4 lg:order-1 lg:col-span-3">
        <div className="sticky top-[72px]">
          <SolicitudStepper
            estado={sol.estado}
            subtipo={sol.subtipo}
            tipo={sol.tipo}
            solicitudId={sol.id}
            contabilizada={sol.enviadaAContabilizacion}
            motivos={sol.motivosBaja}
            dadaDeBajaPorNombre={sol.dadaDeBajaPorNombre}
          />
        </div>
      </div>
      <div className="order-1 col-span-12 md:col-span-8 lg:order-2 lg:col-span-6">
        {enEspera ? <EsperaDeAutorizacionView sol={sol} /> : <DetalleTabs sol={sol} />}
      </div>
      <div className="order-3 col-span-12 lg:col-span-3">
        <DetalleSidebar sol={sol} />
      </div>
    </div>
  );
}
